import { reducersActions } from "../actions/new-actions";

const {
    SET_START_DATE,
    SET_END_DATE,
    CLEAR_DATE_RANGE,
} = reducersActions;

const initialState = {
  startDate: null,
  endDate: null,
};

const dateRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_START_DATE:
      return { ...state, startDate: action.payload };
    case SET_END_DATE:
      return { ...state, endDate: action.payload };
    case CLEAR_DATE_RANGE:
      return { startDate: null, endDate: null };
    default:
      return state;
  }
};

export default dateRangeReducer;
